var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mynavtwo container"},[_c('div',{staticClass:"container col-auto-20 col-s-24"},_vm._l((_vm.contents.con.mynavtwo),function(item,index){return _c('div',{staticClass:"col-auto-8 fl mynavtwo-box"},[_c('div',{},[_c('div',{staticClass:"mynavtwo-img"}),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(item.text))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }